import styles from "../assets/style/ZoomImages.module.scss";

import Picture1 from "../assets/images/p1.jpg";
import Picture2 from "../assets/images/p2.jpg";
import Picture3 from "../assets/images/p3.jpg";
import Picture4 from "../assets/images/p4.jpg";
import Picture5 from "../assets/images/p5.jpg";
import Picture6 from "../assets/images/p6.jpg";
import Video1 from "../assets/images/p7.mp4";

import { useScroll, useTransform, motion } from "framer-motion";
import { useRef } from "react";

export default function ZoomImages() {
  const container = useRef(null);

  const { scrollYProgress } = useScroll({
    target: container,
    offset: ["start start", "end end"],
  });

  const scaleVideo = useTransform(scrollYProgress, [0, 1], [1, 3.5]);

  const scaleSide = useTransform(scrollYProgress, [0, 0.6, 1], [1, 0.6, 0.4]);
  const opacitySide = useTransform(scrollYProgress, [0, 0.55, 1], [1, 0, 0]);

  const textOpacity = useTransform(
    scrollYProgress,
    [0, 0.4, 0.6, 1],
    [0, 0, 1, 1]
  );

  const textY = useTransform(
    scrollYProgress,
    [0, 0.4, 0.6, 1],
    ["0%", "0%", "-20%", "-20%"]
  );

  const leftPushes = [
    useTransform(scrollYProgress, [0, 1], ["0%", "-40%"]),
    useTransform(scrollYProgress, [0, 1], ["0%", "-60%"]),
    useTransform(scrollYProgress, [0, 1], ["0%", "-60%"]),
  ];

  const rightPushes = [
    useTransform(scrollYProgress, [0, 1], ["0%", "60%"]),
    useTransform(scrollYProgress, [0, 1], ["0%", "60%"]),
    useTransform(scrollYProgress, [0, 1], ["0%", "40%"]),
  ];

  const media = [
    {
      src: Picture5,
      scale: scaleSide,
      x: leftPushes[0],
      opacity: opacitySide,
      type: "image",
    },
    {
      src: Picture4,
      scale: scaleSide,
      x: leftPushes[1],
      opacity: opacitySide,
      type: "image",
    },
    {
      src: Picture1,
      scale: scaleSide,
      x: leftPushes[2],
      opacity: opacitySide,
      type: "image",
    },

    { src: Video1, scale: scaleVideo, x: "0%", opacity: 1, type: "video" },

    {
      src: Picture6,
      scale: scaleSide,
      x: rightPushes[0],
      opacity: opacitySide,
      type: "image",
    },
    {
      src: Picture3,
      scale: scaleSide,
      x: rightPushes[1],
      opacity: opacitySide,
      type: "image",
    },
    {
      src: Picture2,
      scale: scaleSide,
      x: rightPushes[2],
      opacity: opacitySide,
      type: "image",
    },
  ];

  return (
    <div ref={container} className={styles.container}>
      <div className={styles.sticky}>
        {media.map(({ src, scale, x, opacity, type }, index) => (
          <motion.div
            key={index}
            className={styles.el}
            style={{ scale, x, opacity }}
          >
            <div className={styles.imageContainer}>
              {type === "image" ? (
                <img src={src} alt="" />
              ) : (
                <>
                  <video src={src} autoPlay loop muted playsInline />
                  <motion.div
                    className={styles.videoText}
                    style={{
                      opacity: textOpacity,
                      y: textY,
                      top: "40%",
                      left: "50%",
                      x: "-50%",
                      yPercent: -50,
                    }}
                  >
                    Strategies That
                    <br />
                    Shape Empires
                  </motion.div>
                </>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
